import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useLayoutEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Method from "@/pages/Method";
import Cohort from "@/pages/Cohort";
import Contact from "@/pages/Contact";
import FieldGuide from "@/pages/FieldGuide";
import Apply from "@/pages/Apply";
import Admin from "@/pages/Admin";
import NotFound from "@/pages/NotFound";

function ScrollToTop() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="paper-grain" aria-hidden="true" />
      <div className="guide-shell">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/method" element={<Method />} />
          <Route path="/cohort" element={<Cohort />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/guide" element={<FieldGuide />} />
          <Route path="/apply" element={<Apply />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
      <Toaster position="bottom-right" theme="dark" />
    </BrowserRouter>
  );
}
